export const getAvailableLanguages = (translations) =>
  Object.keys(translations.language || {});
